'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_navigation_LegacyButton_Button = require('../../navigation/LegacyButton/Button.cjs.js');
const components_marketing_ZapCard_ZapCardSteps = require('./ZapCardSteps.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1ai67_1";
const description = "_description_1ai67_12";
const actions = "_actions_1ai67_21";
const styles = {
	root: root,
	description: description,
	actions: actions
};

const ZapCardDetails = (props) => {
  const target = props.detailsHrefTarget || "_self";
  const editorTarget = props.editorHrefTarget || "_self";
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    React__default.default.createElement(components_marketing_ZapCard_ZapCardSteps.ZapCardSteps, { steps: props.steps }),
    props.children && React__default.default.createElement("div", { className: styles.description, "data-zds": true }, props.children),
    React__default.default.createElement(
      "div",
      null,
      React__default.default.createElement(
        "div",
        { className: styles.actions, "data-zds": true },
        props.detailsHref && React__default.default.createElement(components_navigation_LegacyButton_Button.LegacyButton, { color: "secondary", href: props.detailsHref, size: "small", target }, "See Zap details"),
        props.editorHref && React__default.default.createElement(components_navigation_LegacyButton_Button.LegacyButton, { color: "primary", hasShadow: true, href: props.editorHref, size: "small", target: editorTarget }, "Try it")
      )
    )
  );
};

exports.ZapCardDetails = ZapCardDetails;
//# sourceMappingURL=ZapCardDetails.cjs.js.map
